import RHFInputSearch from "./rhf-input-search.component";

export default RHFInputSearch;
